import { connect } from 'react-redux';
import Messages from '../components/Messages';
import { messages } from '../modules';
import { open } from 'store/modules/modal';

const mapStateToProps = state => {
  return {
    messages: messages(state),
  };
};

const mapDispatchToProps = dispatch => ({
  showPackageErrors(metadata) {
    dispatch(
      open({
        modalType: 'packageErrors',
        modalProps: {
          metadata,
        },
      })
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Messages);
